import styled from 'styled-components'
import { media } from 'utils/styleUtils'
import { CHARCOAL_BLACK, WHITE, PAGAMO_RED } from 'constants/colors'

export const Container = styled.div`
  margin: 0 -1.5rem;
  padding-top: 2rem;
  text-align: center;
`

export const Wrapper = styled.section`
  padding: 2rem 0;
`

export const Categories = styled.ul``

export const Block = styled.li`
  display: inline-block;
  padding: 1rem 1.5rem;
  width: 100%;

  ${media.mobileLandscape} {
    width: 50%;
  }

  ${media.pad} {
    width: 33.3333%;
  }
`

export const Content = styled.div`
  padding: 2rem;
  border-radius: 5px;
  color: ${CHARCOAL_BLACK};
  background-color: ${WHITE};
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    color: ${PAGAMO_RED};
    border-color: ${PAGAMO_RED};
    box-shadow: none;
  }
`
Content.Img = styled.img.attrs(({ category }) => ({
  src: require(`./images/ic_${category}.png`).default,
  alt: '',
}))`
  width: 100px;
  height: 100px;
`
Content.Title = styled.h3`
  margin: 0;
  font-weight: normal;
  white-space: pre-line;

  ${({ category }) =>
    category === 'pacode' &&
    `
      margin-top: -0.78125rem;
      margin-bottom: -0.78125rem;
    `}
`
